export const TYPE = 'utility-ng-type';

const TypeUtility: any = require('utility-ts-type').TypeUtility;

angular.module('utility-ng-type', []).constant('ngTypeUtility', TypeUtility).constant('TypeUtility', TypeUtility);



// WEBPACK FOOTER //
// ./app/vendor/utility-ng-type/src/main.ts